<!-- 
	This is the dashboard page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
  <div>
    <!-- Counter Widgets -->
    <a-row :gutter="24">
      <a-col
        :span="24"
        :lg="12"
        :xl="6"
        class="mb-24"
        v-for="(stat, index) in WciStats"
        :key="index"
      >
        <WidgetCounter
          :title="stat.title"
          :value="stat.value"
          :prefix="stat.prefix"
          :suffix="stat.suffix"
          :icon="stat.icon"
          :status="stat.status"
        ></WidgetCounter>
      </a-col>
    </a-row>

    <a-row :gutter="24">
      <a-col
        :span="24"
        :lg="12"
        :xl="6"
        class="mb-24"
        v-for="(stat, index) in TkStats"
        :key="index"
      >
        <WidgetCounter
          :title="stat.title"
          :value="stat.value"
          :prefix="stat.prefix"
          :suffix="stat.suffix"
          :icon="stat.icon"
          :status="stat.status"
        ></WidgetCounter>
      </a-col>
    </a-row>

    <a-row>
      <a-col :span="24" :lg="24" :xl="24" class="mb-24">
        <a-card :bordered="false" :bodyStyle="{ padding: '0' }">
          <dash-etf-top></dash-etf-top>
        </a-card>
      </a-col>

    </a-row>

    <a-row>
      <a-col :span="24" :lg="24" :xl="24" class="mb-24">
        <a-card :bordered="false" :bodyStyle="{ padding: '0' }">
          <dash-top-chart
            @chartDataChanged="Top25DataChanged"
            @ChartItemClick="ChartItemClick"
          ></dash-top-chart>
        </a-card>
      </a-col>
    </a-row>

    <a-row>
      <a-col :span="24" :lg="24" :xl="24" class="mb-24">
        <a-card :bordered="false" :bodyStyle="{ padding: '0' }">
          <dash-week-chart ref="weekchart"></dash-week-chart>
        </a-card>
      </a-col>
    </a-row>

    <a-row>
      <a-col :span="24" :lg="24" :xl="24" class="mb-24">
        <a-card :bordered="false" :bodyStyle="{ padding: '0' }">
          <dash-week-top-chart ref="weektopchart"></dash-week-top-chart>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getDashboadCardInfo } from "@/api/charts.js";
import WidgetCounter from "@/components/Widgets/WidgetCounter";
import {
  DashTopChart,
  DashWeekChart,
  DashWeekTopChart,
  DashEtfTop,
} from "./components/index";
export default {
  components: {
    WidgetCounter,
    DashTopChart,
    DashWeekChart,
    DashWeekTopChart,
    DashEtfTop,
  },
  data() {
    return {
      WciStats: [
        {
          title: "WCI前日最高",
          value: 0,
          prefix: "",
          suffix: "",
        },
        {
          title: "WCI本月最高",
          value: 0,
          suffix: "",
        },
        {
          title: "WCI前日异动总数",
          value: 0,
          prefix: "",
          status: "danger",
          suffix: "",
        },
        {
          title: "WCI本月异动最高",
          value: 0,
          prefix: "",
          suffix: "",
        },
      ],
      TkStats: [
        {
          title: "Tk前日搜索最高",
          value: 0,
          prefix: "",
          suffix: "",
        },
        {
          title: "Tk前日综合最高",
          value: 0,
          suffix: "",
        },
        {
          title: "Tk本月搜索最高",
          value: 0,
          prefix: "",
          status: "danger",
          suffix: "",
        },
        {
          title: "Tk本月综合最高",
          value: 0,
          prefix: "",
          suffix: "",
        },
      ],
    };
  },
  computed: {},
  created() {
    this.GetCardInfo();
  },
  methods: {
    GetCardInfo() {
      getDashboadCardInfo().then((res) => {
        if (res.code == 0) {
          if (res.data.wci_dayMaxKeyWord) {
            this.WciStats[0].value = res.data.wci_dayMaxKeyWord.totalScore;
            this.WciStats[0].suffix = res.data.wci_dayMaxKeyWord.keyWord;
          }
          if (res.data.wci_monthMaxKeyWord) {
            this.WciStats[1].value = res.data.wci_monthMaxKeyWord.totalScore;
            this.WciStats[1].suffix = res.data.wci_monthMaxKeyWord.keyWord;
          }
          if (res.data.wci_todayFluCount) {
            this.WciStats[2].value = res.data.wci_todayFluCount;
            this.WciStats[2].suffix = "  .";
          }
          if (res.data.wci_monthFluTopKeyWord) {
            this.WciStats[3].value =
              res.data.wci_monthFluTopKeyWord.totalFluCount;
            this.WciStats[3].suffix = res.data.wci_monthFluTopKeyWord.keyword;
          }
          if (res.data.tk_dayMaxSearchKeyWord) {
            this.TkStats[0].value = res.data.tk_dayMaxSearchKeyWord.totalScore;
            this.TkStats[0].suffix = res.data.tk_dayMaxSearchKeyWord.keyWord;
          }
          if (res.data.tk_dayMaxTopKeyWord) {
            this.TkStats[1].value = res.data.tk_dayMaxTopKeyWord.totalScore;
            this.TkStats[1].suffix = res.data.tk_dayMaxTopKeyWord.keyWord;
          }
          if (res.data.tk_monthMaxSearchKeyWord) {
            this.TkStats[2].value =
              res.data.tk_monthMaxSearchKeyWord.totalScore;
            this.TkStats[2].suffix = res.data.tk_monthMaxSearchKeyWord.keyWord;
          }
          if (res.data.tk_monthMaxTopKeyWord) {
            this.TkStats[3].value = res.data.tk_monthMaxTopKeyWord.totalScore;
            this.TkStats[3].suffix = res.data.tk_monthMaxTopKeyWord.keyWord;
          }
        }
      });
    },
    Top25DataChanged(wcidata, tkdata) {
      var wci_ids = wcidata.map((item) => item.keyId);
      var tk_ids = tkdata.map((item) => item.keyId);
      this.$refs.weekchart.GetAllData(wci_ids, tk_ids);
    },
    ChartItemClick(id, dataType) {
      this.$refs.weekchart.SetData(id, dataType);
    },
  },
};
</script>

<style lang="scss">
</style>